import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  getAllReportsData,
  saveAllReportsData,
  exportReportData,
  saveLogEntity,
  getLogEntity,
  getAuditLogs,
} from "../slices";

async function commonPostData(url: string, data: any) {
  try {
    const postApi = api.request({
      method: "POST",
      url: url,
      data,
    });
    const fetchResponse = await postApi;
    return fetchResponse;
  } catch (e) {}
}
export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
}

function* fetchAllReportsData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.REPORTS.getAllReports(),
    });
    yield put(saveAllReportsData(response));
  } catch (error) {
    console.log(error);
  }
}

function* exportReport(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.exportReport(actions.payload.dataToPost.source),
      data: actions.payload.dataToPost,
    });
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchLogEntity() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.REPORTS.logEntity(),
    });
    yield put(saveLogEntity(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchAuditLogs(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.fetchLogReport(),
      data: action.payload.dataToPost,
    });
    action.payload?.callback && action.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getAllReportsData.type, fetchAllReportsData);
  yield takeEvery(exportReportData.type, exportReport);
  yield takeEvery(getLogEntity.type, fetchLogEntity);
  yield takeEvery(getAuditLogs.type, fetchAuditLogs);
}
